import InnerNav from "../../../components/InnerNav/InnerNav";
import Zodiac from "../../../components/ZodiacSign/Zodiac";
import "./Personal.scss";
import arrow from "../../../assets/arrow.png";
import Footer from "../../../components/Footer/Footer";
import { Link } from "react-router-dom";
import axios from "axios";
import { useState } from "react";




// -------------------------------------------------------
// UNLUCKY NUMBER PROFILES (KEPT INSIDE THIS SAME FILE)
// -------------------------------------------------------
export const unluckyProfiles = {
  1: {
    title: "Personal Year 1 – New Beginnings & Independence",
    keywords: "Fresh start · Leadership · Initiative",
    overview:
      "Personal Year 1 marks the beginning of a new 9-year cycle. This year focuses on independence, confidence, and creating new paths.",
    challenges: [
      "Fear of starting something new",
      "Self-doubt despite opportunities",
      "Impatience with slow results",
    ],
    influence:
      "This year pushes you to stand on your own and initiate important life changes.",
    guidance:
      "Take initiative, trust your instincts, and plant seeds for long-term success.",
  },

  2: {
    title: "Personal Year 2 – Patience & Relationships",
    keywords: "Cooperation · Balance · Emotions",
    overview:
      "Personal Year 2 emphasizes relationships, diplomacy, and emotional sensitivity.",
    challenges: [
      "Over-sensitivity",
      "Indecisiveness",
      "Dependence on others’ approval",
    ],
    influence:
      "Progress is subtle. Emotional growth matters more than visible success.",
    guidance:
      "Practice patience, nurture relationships, and avoid forcing outcomes.",
  },

  3: {
    title: "Personal Year 3 – Creativity & Expression",
    keywords: "Creativity · Communication · Joy",
    overview:
      "A year of self-expression, creativity, and social interaction.",
    challenges: [
      "Lack of focus",
      "Overindulgence",
      "Scattered energy",
    ],
    influence:
      "This year encourages artistic pursuits, communication, and optimism.",
    guidance:
      "Express yourself freely but stay disciplined to avoid wasted energy.",
  },

  4: {
    title: "Personal Year 4 – Discipline & Stability",
    keywords: "Hard work · Structure · Foundation",
    overview:
      "Personal Year 4 is about building strong foundations through effort and discipline.",
    challenges: [
      "Feeling restricted",
      "Work pressure",
      "Resistance to change",
    ],
    influence:
      "Life demands responsibility, planning, and persistence.",
    guidance:
      "Stay organized, work patiently, and focus on long-term security.",
  },

  5: {
    title: "Personal Year 5 – Change & Freedom",
    keywords: "Transformation · Travel · Adaptability",
    overview:
      "A year of change, movement, and unexpected opportunities.",
    challenges: [
      "Instability",
      "Impulsive decisions",
      "Difficulty committing",
    ],
    influence:
      "Rapid changes may occur in career, location, or relationships.",
    guidance:
      "Stay flexible but avoid reckless choices.",
  },

  6: {
    title: "Personal Year 6 – Responsibility & Family",
    keywords: "Home · Love · Commitment",
    overview:
      "This year highlights family matters, relationships, and emotional responsibility.",
    challenges: [
      "Overburdening yourself",
      "Emotional stress",
      "People-pleasing",
    ],
    influence:
      "Focus shifts toward home, marriage, and long-term commitments.",
    guidance:
      "Maintain balance between caring for others and self-care.",
  },

  7: {
    title: "Personal Year 7 – Introspection & Spiritual Growth",
    keywords: "Reflection · Wisdom · Inner growth",
    overview:
      "A quiet, introspective year focused on learning and spiritual development.",
    challenges: [
      "Isolation",
      "Overthinking",
      "Lack of motivation for material goals",
    ],
    influence:
      "External progress slows so inner growth can deepen.",
    guidance:
      "Study, reflect, and trust the process rather than forcing results.",
  },

  8: {
    title: "Personal Year 8 – Power & Achievement",
    keywords: "Career · Finance · Authority",
    overview:
      "A strong year for material success, recognition, and karmic results.",
    challenges: [
      "Work pressure",
      "Power struggles",
      "Financial stress",
    ],
    influence:
      "Efforts from previous years begin to show tangible rewards.",
    guidance:
      "Act ethically, stay disciplined, and manage power responsibly.",
  },

  9: {
    title: "Personal Year 9 – Completion & Letting Go",
    keywords: "Endings · Closure · Release",
    overview:
      "The final year of the cycle, focused on closure and emotional release.",
    challenges: [
      "Emotional sensitivity",
      "Difficulty letting go",
      "Unexpected endings",
    ],
    influence:
      "Old chapters close to make space for a new beginning next year.",
    guidance:
      "Release the past and prepare for a fresh cycle ahead.",
  },

  11: {
    title: "Personal Year 11 – Spiritual Awakening",
    keywords: "Intuition · Inspiration · Sensitivity",
    overview:
      "A master year of heightened intuition and spiritual insight.",
    challenges: [
      "Emotional overwhelm",
      "Anxiety",
      "Lack of grounding",
    ],
    influence:
      "Strong spiritual lessons and inner awareness develop.",
    guidance:
      "Stay grounded and channel intuition constructively.",
  },

  22: {
    title: "Personal Year 22 – Master Builder Year",
    keywords: "Manifestation · Responsibility · Legacy",
    overview:
      "A powerful year to build something lasting and meaningful.",
    challenges: [
      "Pressure",
      "Fear of failure",
      "Heavy responsibilities",
    ],
    influence:
      "Great potential exists if discipline is maintained.",
    guidance:
      "Plan carefully and take steady, practical action.",
  },

  33: {
    title: "Personal Year 33 – Compassion & Service",
    keywords: "Healing · Sacrifice · Higher purpose",
    overview:
      "A rare master year emphasizing service, compassion, and emotional healing.",
    challenges: [
      "Burnout",
      "Overgiving",
      "Emotional exhaustion",
    ],
    influence:
      "Deep emotional lessons and service-oriented roles emerge.",
    guidance:
      "Help others while protecting your own emotional well-being.",
  },
};



// --- Profiles remain unchanged ---
// import { unluckyProfiles } from "./unluckyProfiles"; // If separate file, else keep your object

const Personal = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    year: "2000",
    month: "May",
    day: "26",
    gender: "male" // ✅ DEFAULT, NO UI
  });

  const [resultData, setResultData] = useState(null);
  const [showReport, setShowReport] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { firstName, lastName, year, month, day } = formData;
    const birthDay = Number(day);
    const birthMonth = new Date(`${month} 1, 2000`).getMonth() + 1;
    const birthYear = Number(year);

    try {
      setLoading(true);

      const { gender } = formData;

      const res = await axios.get(
        `https://core-c343.onrender.com/api/lucky-number` +
        `?firstName=${firstName}` +
        `&lastName=${lastName}` +
        `&birthYear=${birthYear}` +
        `&birthMonth=${birthMonth}` +
        `&birthDay=${birthDay}` +
        `&gender=${gender}`
      );

      setResultData(res.data);
      setShowReport(true);
    } catch (error) {
      console.error("API error:", error);
      setResultData({
        error: "Unable to compute unlucky number. Please try again.",
      });
      setShowReport(true);
    } finally {
      setLoading(false);
    }
  };

  const handleTryAgain = () => {
    setShowReport(false);
    setResultData(null);
  };

  // 🔥 UPDATED: Read unlucky number correctly from API
  // const unluckyNum = resultData?.data?.numerology?.numbers?.[0];
  const unluckyNum = resultData?.data?.numerology?.personalYear;

  // 🔥 Profile for this unlucky number
  const profile = unluckyProfiles[unluckyNum];

  return (
    <div className="unlucky-container">
      <InnerNav />

      <div className="unlucky-content">
        <Zodiac />

        <div className="left-unlucky">
          {/* ---------------- FORM VIEW ---------------- */}
          {!showReport && (
            <>
<div className="header">
  <h1>Personal Year Calculator</h1>
  <p>
    Discover your Personal Year Number and understand the key themes,
    challenges, and opportunities influencing your life this year.
  </p>
</div>


              <div className="card1">
                <h3>Enter Your Details</h3>

                <form className="card-content" onSubmit={handleSubmit}>
                  <input
                    type="text"
                    name="firstName"
                    placeholder="First Name"
                    value={formData.firstName}
                    onChange={handleChange}
                    required
                  />

                  <input
                    type="text"
                    name="middleName"
                    placeholder="Middle Name (Optional)"
                    value={formData.middleName}
                    onChange={handleChange}
                  />

                  <input
                    type="text"
                    name="lastName"
                    placeholder="Last Name"
                    value={formData.lastName}
                    onChange={handleChange}
                    required
                  />

                  <select name="year" value={formData.year} onChange={handleChange}>
                    {Array.from({ length: 110 }).map((_, i) => {
                      const y = 2025 - i;
                      return (
                        <option key={y} value={y}>
                          {y}
                        </option>
                      );
                    })}
                  </select>

                  <select name="month" value={formData.month} onChange={handleChange}>
                    {[
                      "January","February","March","April","May","June",
                      "July","August","September","October","November","December",
                    ].map((m) => (
                      <option key={m}>{m}</option>
                    ))}
                  </select>

                  <select name="day" value={formData.day} onChange={handleChange}>
                    {[...Array(31)].map((_, i) => (
                      <option key={i + 1} value={i + 1}>
                        {i + 1}
                      </option>
                    ))}
                  </select>
                                    <select
                    name="gender"
                    value={formData.gender}
                    onChange={handleChange}
                    required
                  >
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="other">Other</option>
                  </select>

                  <button type="submit" disabled={loading}>
                    {loading ? "Generating Report..." : "Show My Unlucky Number"}
                  </button>
                </form>
              </div>
            </>
          )}

          {/* ---------------- REPORT VIEW ---------------- */}
{showReport && (
  <div className="report-card">
    <h1>Your Personal Year Report</h1>

    {resultData?.error ? (
      <p className="error-text">{resultData.error}</p>
    ) : (
      <>
        {/* MAIN NUMBER DISPLAY */}
        <div className="hero-number-box">
          <div className="number-circle">{unluckyNum}</div>
          <h2>{profile?.title}</h2>
          <p className="keywords">{profile?.keywords}</p>
        </div>

        {/* USER DETAILS */}
        <div className="report-section">
          <h3>Your Details</h3>
          <p>
            <strong>Name:</strong> {formData.firstName}{" "}
            {formData.middleName} {formData.lastName}
          </p>
          <p>
            <strong>Date of Birth:</strong> {formData.day} {formData.month}{" "}
            {formData.year}
          </p>
        </div>

        {/* PERSONAL YEAR EXPLANATION */}
        <div className="report-section">
          <h3>What This Personal Year Means</h3>
          <p>
            Your Personal Year Number represents the main life theme influencing
            your experiences, decisions, and opportunities during this year.
          </p>
        </div>

        {/* PROFILE CONTENT */}
        <div className="report-section">
          <h3>Overview</h3>
          <p>{profile?.overview}</p>
        </div>

        <div className="report-section">
          <h3>Influence in Your Life This Year</h3>
          <p>{profile?.influence}</p>
        </div>

        <div className="report-section">
          <h3>Key Challenges This Year</h3>
          <ul>
            {profile?.challenges?.map((c, i) => (
              <li key={i}>{c}</li>
            ))}
          </ul>
        </div>

        <div className="report-section">
          <h3>Guidance for This Personal Year</h3>
          <p>{profile?.guidance}</p>
        </div>
      </>
    )}

    <button className="try-again-btn" onClick={handleTryAgain}>
      Try Again
    </button>
  </div>
)}

        </div>

        {/* RIGHT SIDEBAR */}
        <div className="right-numerology">
          <h4>Popular in Numerology</h4>
          <div className="right-links">
                       <Link to="/numerology/luckynum"><p><img src={arrow}/> Lucky Number</p></Link>
            <Link to="/numerology/chinese-lucky"><p><img src={arrow}/> Chinese Lucky</p></Link>
            <Link to="/numerology/unlucky"><p><img src={arrow}/> Unlucky Number</p></Link>
            <Link to="/numerology/life-path"><p><img src={arrow}/> Life Path</p></Link>
            <Link to="/numerology/destiny"><p><img src={arrow}/> Destiny Number</p></Link>
            <Link to="/numerology/birth"><p><img src={arrow}/> Birth or Root Number</p></Link>
            <Link to="/numerology/soul"><p><img src={arrow}/> Soul Urge Number</p></Link>
            <Link to="/numerology/name"><p><img src={arrow}/> Name Number</p></Link>
            <Link to="/numerology/balance"><p><img src={arrow}/> Balance Number</p></Link>
            <Link to="/numerology/lo-shu-grid"><p><img src={arrow}/> Lo Shu Grid Analysis</p></Link>
            <Link to="/numerology/kua"><p><img src={arrow}/> Kua Number</p></Link>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Personal;
